// 值处理
import { assign } from 'lodash'
import {getObjectStringList, getFieldObject, checkObjectAttr} from './base'

export default function (formData, mainObjectName, fieldMaps = {}, isEdit = false) {
  const fieldMap = fieldMaps[mainObjectName]
  _process(formData, fieldMap, fieldMaps, isEdit)
}

// 从对象
function _processList (list, fieldMap, isEdit) {
  list.forEach(item => {
    _process(item, fieldMap, {}, isEdit)
  })
}

// 主要方法
function _process (formData, fieldMap, fieldMaps = {}, isEdit) {
  for (let key in fieldMap) {
    let field = fieldMap[key]
    if (field.isMasterRelation) {
      if (!formData[field.apiName]) {
        // formData[field.apiName] = []
        window.Vue.set(formData, field.apiName, [])
      }
      _processList(formData[field.apiName], fieldMaps[field.objectApiName], isEdit)
    } else {
      let {attr, apiName} = field
      let objStringList = getObjectStringList(apiName)
      if (field.__innerField || field.__isUse || checkObjectAttr(formData, objStringList)) {
        let fieldObject = getFieldObject(formData, objStringList, true)
        if (fieldObject) {
          let lastObjString = objStringList[objStringList.length - 1]
          window.Vue.set(fieldObject, lastObjString, attr?.defaultValue(fieldObject[lastObjString], field, isEdit))
          // fieldObject[lastObjString] = attr?.defaultValue(fieldObject[lastObjString], field, isEdit)
        }
      }
    }
  }
}

// 从对象初始化行
export function initLine (fieldMap, lineData = {}) {
  const _lineData = assign({}, lineData)
  _process(_lineData, fieldMap)
  return _lineData
}
